import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fontsource/chakra-petch/300.css';
import '@fontsource/chakra-petch/400.css';
import '@fontsource/chakra-petch/700.css';
import '@styles/index.scss';
import '@assets/i18n';
import App from 'App';
import reportWebVitals from 'reportWebVitals';
import store from 'store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'leaflet/dist/leaflet.css';

serviceWorkerRegistration.register();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

reportWebVitals();
